import React, { useCallback, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { stringify, parse } from 'query-string';
import { CustomeMenu, MenuItemStyle, Root } from './styled-comps';
import { Menu } from 'semantic-ui-react';
import { COLORS, Text } from '@cuemath/comps';
import { CSM_TAB_MENU } from './tabs';

const CsmDetailsMenu = () => {
  const location = useLocation();
  const { search } = location;
  const history = useHistory();
  const { activeTab } = parse(search);

  useEffect(() => {
    const tabConfig = activeTab
      ? CSM_TAB_MENU.find(({ path }) => path === activeTab)
      : CSM_TAB_MENU[0];
    const { path } = tabConfig;

    if (path && path !== activeTab) {
      history.replace({
        search: stringify({ activeTab: path }),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  const handleTabClick = useCallback(
    (_e, { name }) => {
      history.replace({
        search: stringify({ activeTab: name }),
      });
    },
    [history],
  );

  return (
    <Root>
      <CustomeMenu pointing secondary>
        {CSM_TAB_MENU.map(tab => {
          const isActive = activeTab === tab.path;
          const menuItemStyles = {
            ...MenuItemStyle,
            color: isActive ? COLORS.COLA : COLORS.GRAY_LIGHT,
          };

          return (
            <Menu.Item
              key={tab.path}
              style={menuItemStyles}
              name={tab.path}
              active={isActive}
              onClick={handleTabClick}
            >
              <Text color={menuItemStyles.color}>{tab.name}</Text>
            </Menu.Item>
          );
        })}
      </CustomeMenu>
    </Root>
  );
};

export default CsmDetailsMenu;
